<template>
  <ShadcnButton
    :variant="shadcnVariant"
    :size="size"
    :disabled="disabled"
    @click="emitClick"
  >
    <slot />
  </ShadcnButton>
</template>

<script setup>
import { computed } from "vue";
import ShadcnButton from "@/shared/ui/button/Button.vue";

const props = defineProps({
  type: {
    type: String,
    default: "primary",
  },
  size: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["click"]);

const emitClick = (event) => {
  emit("click", event);
};

// Map Element Plus type → shadcn variant
const shadcnVariant = computed(() => {
  const map = {
    primary: "default",
    success: "default",
    warning: "secondary",
    danger: "destructive",
    info: "secondary",
    default: "outline",
    "": "outline",
  };
  return map[props.type] || "default";
});
</script>
